module.exports = __webpack_public_path__ + "img/header_background.408cb0a4.png";